import { cnpj, cpf } from 'cpf-cnpj-validator';
import { StringSchema } from 'yup';
import { onlyNumbers } from '@/utils/string';

export default function (this: StringSchema, message = 'Insira um CPF ou CNPJ válido') {
  return this.test('cpfOrCnpj', message, (value = '') => {
    if (value.includes('*')) return true;

    const cpfCnpj = onlyNumbers(value);
    const validate = cpfCnpj.length <= 11 ? cpf.isValid : cnpj.isValid;
    return validate(cpfCnpj);
  });
}
